// extracted by mini-css-extract-plugin
module.exports = {"infoPanel":"challenges_infoPanel__3NCh7"};